import { miscConstants } from '../../constants';
import { miscService } from '../../services';
import { alertActions } from '..';
import { generalErrorHandler, resetAbortController } from '../utils';

export default function loadPreference() {
  return dispatch => {
    const ac = resetAbortController(miscConstants.LOAD_PREF_REQUEST);
    dispatch(request());
    dispatch(alertActions.clear());

    return miscService.loadPreference(ac.signal).then(
      preference => {
        dispatch(success(preference));
        if (Object.keys(preference).length === 0) {
          let p = {};
          try {
            p = JSON.parse(localStorage['preference']);
          } catch {
            console.error(
              'Cannot load preference from localStorage',
              localStorage['preference']
            );
          }
          console.log('Uploading user preference');
          for (const key in p) {
            const value = p[key];
            if (key !== 'UserId') {
              miscService.storePreference(null, key, value);
            }
          }
        }
      },
      generalErrorHandler(dispatch, error =>
        dispatch(failure(error.toString()))
      )
    );
  };

  function request() {
    return { type: miscConstants.LOAD_PREF_REQUEST };
  }
  function success(preference) {
    return { type: miscConstants.LOAD_PREF_SUCCESS, preference };
  }
  function failure(error) {
    return { type: miscConstants.LOAD_PREF_FAILURE, error };
  }
}
